import React from "react";
import "./loader.scss";

function Loader() {
	return <div className="loader"></div>;
}

export default Loader;
